import { render, staticRenderFns } from "./buySaleH5.vue?vue&type=template&id=3fff6ad5&scoped=true"
import script from "./buySaleH5.vue?vue&type=script&lang=js"
export * from "./buySaleH5.vue?vue&type=script&lang=js"
import style0 from "./buySaleH5.vue?vue&type=style&index=0&id=3fff6ad5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fff6ad5",
  null
  
)

export default component.exports